<template>
  <Modal v-model="visible" :width="900" footer-hide>
    <p slot="header">
      <span>{{ title }}</span>
      <lzDicTxt class="status-text" :class="['status--' + detailData.status]" :dicCode="detailData.status" dicType="AGENT_SIGN_STATUS" />
    </p>
    <Form v-if="visible" :label-width="120" class="page-form">
      <div class="form-title">基础信息</div>
      <FormItem label="姓名">
        <div class="form-item-content">{{ detailData.name || '-' }}</div>
      </FormItem>
      <FormItem label="业务员工号">
        <div class="form-item-content">{{ detailData.staffNo || '-' }}</div>
      </FormItem>
      <FormItem label="手机号">
        <div class="form-item-content">
          <!-- {{ detailData.mobile || '-' }} -->
          <sensitiveView :data="detailData" queryKey="id" keyName="mobile" dataType="2" fun="62" />
        </div>
      </FormItem>
      <FormItem label="业务员状态">
        <div class="form-item-content">{{ detailData.workingState | workingStateFilter }}</div>
      </FormItem>
      <FormItem label="证件类型">
        <div class="form-item-content">{{ detailData.idType | filterCardType }}</div>
      </FormItem>
      <FormItem label="证件号">
        <div class="form-item-content">
          <!-- {{ detailData.idNo || '-' }} -->
          <sensitiveView :data="detailData" queryKey="id" keyName="idNo" dataType="1" fun="62" />
        </div>
      </FormItem>
      <FormItem label="性别">
        <div class="form-item-content">{{ detailData.gender | filterSex }}</div>
      </FormItem>
      <FormItem label="出生日期">
        <div class="form-item-content">{{ detailData.birthDate | dateFilter('-') }}</div>
      </FormItem>
      <FormItem label="学历">
        <div class="form-item-content">
          <lzDicTxt :dicCode="detailData.education" dicType="EDUCATION" />
        </div>
      </FormItem>
      <FormItem label="所属机构">
        <div class="form-item-content">{{ detailData.orgName || '-' }}</div>
      </FormItem>
      <FormItem label="所属团队">
        <div class="form-item-content">{{ detailData.groupName || '-' }}</div>
      </FormItem>
      <!-- <FormItem label="上游工号状态">
        <lzDicTxt :dicCode="detailData.status" dicType="AGENT_SIGN_STATUS" />
      </FormItem> -->
      <!-- <FormItem label="上号保司">{{ detailData.company || '-' }}</FormItem>
      <FormItem label="上游保司工号">{{ detailData.companyStaffNo || '-' }}</FormItem> -->
      <FormItem label="邮箱">
        <div class="form-item-content">
          <!-- {{ detailData.email || '-' }} -->
          <sensitiveView :data="detailData" queryKey="id" keyName="email" dataType="4" fun="62" />
        </div>
      </FormItem>
      <FormItem label="民族">
        <div class="form-item-content">{{ detailData.nation || '-' }}</div>
      </FormItem>
      <FormItem label="政治面貌">
        <div class="form-item-content">
          <!-- {{ detailData.politicalOutlook || '-' }} -->
          <lzDicTxt :dicCode="detailData.politicalOutlook" dicType="OUTLOOK"></lzDicTxt>
        </div>
      </FormItem>
      <FormItem label="入职日期">
        <div class="form-item-content">{{ detailData.entryDate || '-' }}</div>
      </FormItem>
      <FormItem label="联系地址">
        <div class="form-item-content">
          <!-- {{ detailData.address || '-' }} -->
          <sensitiveView :data="detailData" queryKey="id" keyName="address" dataType="5" fun="62" />
        </div>
      </FormItem>
      
      <div class="form-title">执业证信息</div>
      <FormItem label="执业证编号" class="full">
        <div class="form-item-content">{{ detailData.licenseNumber || '-' }}</div>
      </FormItem>
      <FormItem label="执业证登记日期">
        <div class="form-item-content">{{ detailData.licenseRegistrationDate || '-' }}</div>
      </FormItem>
      <FormItem label="执业证注销日期">
        <div class="form-item-content">{{ detailData.licenseDeadline || '-' }}</div>
      </FormItem>
      <FormItem label="执业证打印日期">
        <div class="form-item-content">{{ detailData.licensePrintDate || '-' }}</div>
      </FormItem>
      <FormItem label="执业证截止日期">
        <div class="form-item-content">{{ detailData.licenseDeadline || '-' }}</div>
      </FormItem>

      <div class="form-title">销售等级与证书</div>
      <!-- <p class="info-box-title"><span class="text">销售等级与证书</span></p> -->
      <!-- 销售分级/等级（选择——枚举：一级、二级、三级、四级） -->
      <FormItem label="销售分级/等级" :label-width="110">
        <div class="form-item-content">
          <span v-if="!detailData.agentLevel">-</span>
          <lzDicTxt v-else :dicCode="detailData.agentLevel" dicType="AGENT_LEVEL" />
        </div>
      </FormItem>
      <!-- 分级/等级考试通过时间（时间插件） -->
      <FormItem label="分级/等级考试通过时间" :label-width="160">
        <div class="form-item-content">{{ detailData.agentLevelTime || '-' }}</div>
      </FormItem>
      <!-- 资格证类型（选择——枚举：A、空） -->
      <FormItem label="资格证类型">
        <div class="form-item-content">
          <span v-if="!detailData.certificateType">-</span>
          <lzDicTxt v-else :dicCode="detailData.certificateType" dicType="CERTIFICATE_TYPE" />
        </div>
      </FormItem>
      <!-- 万能/分红销售证（单选选择是、否） -->
      <FormItem label="分红万能险销售证" :label-width="135">
        <div class="form-item-content">
          <span v-if="detailData.hasWannengCertificate == '1'">是</span>
          <span v-else-if="detailData.hasWannengCertificate == '0'">否</span>
          <span v-else>-</span>
        </div>
      </FormItem>
      <!-- 万能/分红证书号（填写） -->
      <FormItem label="分红万能险证书编号" :label-width="145">
        <div class="form-item-content">{{ detailData.wannengCertificateNo || '-' }}</div>
      </FormItem>
      <!-- 万能/分红证证书有效起期（时间插件） -->
      <FormItem label="分红万能险证书有效起期" :label-width="170">
        <div class="form-item-content">{{ detailData.wannengCertificateStartDate || '-' }}</div>
      </FormItem>
    </Form>
  </Modal>
</template>

<script>
import filters from '@/api/filter';
import lzDicTxt from '@/components/commons/lzDicTxt.vue';
import sensitiveView from '@/components/commons/sensitiveView';
import dayjs from 'dayjs';
const workingStateMap = {
  '1': '在职',
  '0': '离职'
};
export default {
  mixins: [filters],
  components: { lzDicTxt, sensitiveView },
  data() {
    return {
      title: '',
      visible: false,
      detailData: {}
    };
  },
  filters: {
    workingStateFilter(v) {
      return workingStateMap[v] || '-';
    },
    dateFilter(v, defV) {
      console.log('dateFilter', v);
      if (Object.prototype.toString.call(v) === '[object Date]') {
        return dayjs(v)
          .format('YYYY-MM-DD')
          .toString();
      } else if (typeof v === 'string') {
        return v.substring(0, 10);
      } else {
        return defV || '';
      }
    }
  },
  methods: {
    open(opts) {
      this.opts = opts;
      this.visible = true;
      const id = opts.id;
      this.$http({
        url: '/buz/okbao/agent/detail',
        type: 'GET',
        data: {
          id
        },
        apiPermissionCode: 'org_200_1'
      }).then(res => {
        console.log('res', res);
        const d = res.data;
        d.id = id;
        if (d.status == '') {
          d.status = -2;
        }
        this.detailData = d;
        this.title = `${d.name}/${d.staffNo}——${d.company}`;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.info-box-title {
  position: relative;
  height: 40px;

  .text {
    font-weight: 500;
    font-size: 1.2em;
    color: #333;
    display: block;
    position: absolute;
    z-index: 2;
    height: 30px;
    line-height: 30px;
    margin-top: -15px;
    left: 0;
    top: 50%;
    padding-right: 10px;
    background-color: #fff;
  }

  &::after {
    content: '';
    position: absolute;
    z-index: 1;
    height: 1px;
    width: 100%;
    top: 50%;
    left: 0;
    background-color: #e8eaec;
  }
}
.status-text {
  display: inline-block;
  height: 18px;
  line-height: 16px;
  border-radius: 4px;
  margin-left: 10px;
  border: 1px solid #333;
  font-size: 0.7em;
  padding: 0 4px;
  box-sizing: border-box;
  vertical-align: text-top;

  // 待开通
  &.status---2 {
    color: #888888;
    border-color: #888888;
    background-color: #f5f5f5;
  }
  // 开通失效
  &.status---1 {
    color: #888888;
    border-color: #888888;
    background-color: initial;
  }
  // 开通中
  &.status--0 {
    color: #34a1ff;
    border-color: #34a1ff;
    background-color: #eaf5ff;
  }
  // 已开通
  &.status--1 {
    color: #5bc37f;
    border-color: #5bc37f;
    background-color: #e2ffec;
  }
  // 注销中
  &.status--2 {
    color: #888888;
    border-color: #888888;
    background-color: #f5f5f5;
  }
  // 已注销
  &.status--3 {
    color: #888888;
    border-color: #888888;
    background-color: initial;
  }
}
</style>
